














































































































import { defineComponent } from '@vue/composition-api';
import { mapState } from 'vuex';
import InputRulesHelper from '@/helpers/InputRulesHelper';
import IntegratorRepository from '@/repositories/integrator/IntegratorRepository';
import Company from '@/domain/models/Company';
import { VForm } from '@/types/VForm';
import ISelectOptions from '@/domain/interfaces/ISelectOptions';
import BranchConfiguration from '@/domain/models/integrator/BranchConfiguration';
import IntegratorBranchConfigurations from '../interfaces/forms/IntegratorBranchConfigurations';
import IntegratorBranchConfigurationsRequest from '../interfaces/requests/IntegratorBranchConfigurationsRequest';

export default defineComponent({
	name: 'IntegratorBranchConfigurationsTab',
	data() {
		const inputRules: InputRulesHelper = new InputRulesHelper();
		const integratorRepository:
			IntegratorRepository = new IntegratorRepository();

		const branchConfigurationsFormData: IntegratorBranchConfigurations = {
			companyId: NaN,
      databaseAlias: '',
		};

    const branchConfigurationList: BranchConfiguration[] = [];

		const loading: boolean = false;
    const actualRegisterIndex: number|undefined = undefined;

		return {
			inputRules,
			integratorRepository,
      branchConfigurationsFormData,
      branchConfigurationList,
			loading,
      actualRegisterIndex: actualRegisterIndex as number|undefined,
		};
	},
  props: {
    companies: {
      required: true,
      type: Array as () => Company[],
    },
  },
	computed: {
    ...mapState({
      companyGroupId: (state: any) => state.authentication.user.company_group_id as number,
    }),
    companyOptions(): ISelectOptions<number>[] {
      const companyIdsExistentOnList = this.branchConfigurationList
        .map(({ companyId }) => companyId);

      return this.companies
        .filter((company) => (
          !companyIdsExistentOnList.includes(company.id)
          || (this.branchConfigurationsFormData.companyId === company.id)
        ))
        .map((company) => ({ value: company.id, text: company.fantasyName }));
    },
  },
	created() {
		this.getIntegratorBranchConfigurationData();
	},
	methods: {
		async getIntegratorBranchConfigurationData(): Promise<void> {
			try {
				this.loading = true;

				const branchConfigurationList = await this.integratorRepository
					.getBranchConfiguration(this.companyGroupId);

          this.branchConfigurationList = branchConfigurationList;
			} catch (error) {
				this.$notification.error('Houve um problema ao requisitar os dados de configuração do Sinalizador de Recurso');
			} finally {
				this.loading = false;
			}
		},
    getCompanyNameById(companyId: number): string {
      const company = this.companies.find((company) => company.id === companyId);

      if (!company) {
        return '';
      }

      return company.fantasyName;
    },
    emptyFields(): void {
      this.branchConfigurationsFormData.databaseAlias = '';
      this.branchConfigurationsFormData.companyId = NaN;

      this.actualRegisterIndex = undefined;

      const integratorBranchConfigurationsForm = this.$refs
        .IntegratorBranchConfigurationsForm as VForm;

      integratorBranchConfigurationsForm.resetValidation();
    },
		async handleClickSave(): Promise<void> {
			try {
				this.$dialog.startLoading();

				const requestData = this.validateFormAndGetValuesRequest();

				if (!requestData) {
					return;
				}

				await this.integratorRepository
					.setBranchConfigurationList(this.companyGroupId, requestData);

        this.$notification.success('Configuração de Empresa/Filial gravada com sucesso.');
			} catch (error) {
				this.$notification.error('Houve um problema ao salvar o arquivo de configuração do Sinalizador de Recurso');
			} finally {
				this.$dialog.stopLoading();
			}
		},
    async handleRemove(index: number): Promise<void> {
      try {
        this.$dialog.startLoading();

        this.branchConfigurationList.splice(index, 1);

        const formattedBranchConfiguration = this.branchConfigurationList.map((data) => ({
          database_alias: data.databaseAlias,
          company_id: data.companyId,
        }));

        await this.integratorRepository.setBranchConfigurationList(
          this.companyGroupId,
          formattedBranchConfiguration,
        );

        this.$notification.success('Configuração de Empresa/Filial removida com sucesso.');
      } catch (error) {
        this.$notification.error('Houve um problema ao remover o registro');
      } finally {
        this.$dialog.stopLoading();
      }
    },
    handleEdit(index: number, data: BranchConfiguration): void {
      this.branchConfigurationsFormData.databaseAlias = data.databaseAlias;
      this.branchConfigurationsFormData.companyId = data.companyId;
      this.actualRegisterIndex = index;

      this.branchConfigurationList.splice(index, 1);
    },
    handleAddBranchConfigurations(): void {
			const integratorBranchConfigurationsForm = this.$refs
        .IntegratorBranchConfigurationsForm as VForm;

			if (!integratorBranchConfigurationsForm.validate()) {
				this.$notification.error('Há campos preenchidos incorretamente!');
				return;
			}

      this.branchConfigurationList.push({ ...this.branchConfigurationsFormData });

      this.emptyFields();
    },
		validateFormAndGetValuesRequest(): IntegratorBranchConfigurationsRequest[]|null {
      return this.branchConfigurationList.map((data) => ({
        database_alias: data.databaseAlias,
        company_id: data.companyId,
      }));
		},
	},
});
